import { Siparis } from './siparis';
import { IrsaliyeKalem } from './irsaliye-kalem';

export class Irsaliye {

  public static DURUM_OLUSTURULDU = 0;

  id: number;
  irsaliyeNotu: string;
  siparis: Siparis;
  siparisId: number;
  durum: number;
  olusturmaTarihi: string;
  irsaliyeNo: string;
  private pIrsaliyeKalemler: IrsaliyeKalem[];
  irsaliyeTarihi: Date;
  netsisIslendi: boolean;


  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.siparis != null) {
      this.siparis = new Siparis(obj.siparis);
    }
  }


  get durumText(): string {
    if (this.durum != null) {
      switch (this.durum) {
        case Irsaliye.DURUM_OLUSTURULDU:
          return 'Oluşturuldu';
      }
    }
    return '';
  }

  get olusturmaTarihiText(): string {
    if (this.olusturmaTarihi != null) {
      const date = new Date(this.olusturmaTarihi);
      return date.toLocaleString();
    }
    return '';
  }


  public get irsaliyeKalemler(): IrsaliyeKalem[] {
    return this.pIrsaliyeKalemler;
  }

  public set irsaliyeKalemler(list: IrsaliyeKalem[]) {
    if (list != null) {
      this.pIrsaliyeKalemler = list.map(t => new IrsaliyeKalem(t));
    }
  }

  get irsaliyeTarihiText(): string {
    if (this.irsaliyeTarihi != null) {
      const date = new Date(this.irsaliyeTarihi);
      return date.toLocaleString();
    }
    return '';
  }

  get toplamAdet(): number {
    let toplamAdet = 0;

    for (var item of this.irsaliyeKalemler) {
      toplamAdet += item.adet;
    }
    return toplamAdet;
  }

  get toplamTutar(): number {
    let toplamTutar = 0;

    for (var item of this.irsaliyeKalemler) {
      toplamTutar += item.tutar * item.adet;
    }
    return toplamTutar;
  }


}
